export default __webpack_public_path__ + "1e4e5b087bf9f47bc105ce337212745f.png";